<mat-icon ngxTippy [ngxTippy]="tippyTemplate">info</mat-icon>
<div #tippyTemplate>
  <div [innerHTML]="to.tooltip"></div>
</div>
